import { render } from "./Dashboard.vue?vue&type=template&id=3ba8e976&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=3ba8e976&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=3ba8e976&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba8e976"]])

export default __exports__